import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

// cubbies-43b14 = Qubby AI SaaS（既有帳號系統，SSO source of truth）
// admin-console 用同一組帳號，server.js 額外驗 users/{uid}.ivrMode === true
const firebaseConfig = {
    apiKey: 'AIzaSyA7S7hDHuwSRWa5rc46cQYGBnKHc-ubqKI',
    authDomain: 'cubbies-43b14.firebaseapp.com',
    projectId: 'cubbies-43b14',
    storageBucket: 'cubbies-43b14.appspot.com',
    messagingSenderId: '655633798281',
    appId: '1:655633798281:web:45c367f48d36b4fa262258',
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
